// extracted by mini-css-extract-plugin
module.exports = {"Value":"Value--AZMD1","Primary":"Primary--ED1uT"};